<section [formGroup]="stepForm">
  <mbs-card
    class="mbs-plan-detail h-auto"
    [customClasses]="'bg-light border-radius-xl-important h-auto'"
    [hasPadding]="false"
    [id]="'retore-ibb-to-vm-settings'"
    [innerBordered]="false"
    [size]="MbsSize.xs">
    <mbs-card-group class="w-100 p-3">
      <mbs-vm-name-field
        [editValidationError]="vmNameEditValidationError.bind(this)"
        [loading]="virtualMachinesLoading()"
        [machines]="vmNameFieldMachines()"
        [mode]="vmNameFieldMode()"
        [overwrite]="value()?.overwrite"
        [selectId]="'retore-ibb-to-vm-settings-name-select'"
        [selectMaxWidth]="'564px'"
        [switcherId]="'vm-settings-overwrite-switcher'"
        [value]="vmNameFieldValue()"
        (overwriteChange)="overwriteChangeHandler($event)"
        (validityChange)="vmNameFieldValidityChangeHandler($event)"
        (valueChange)="vmNameFieldChangeHandler($event)"></mbs-vm-name-field>
    </mbs-card-group>

    <mbs-card-group class="w-100 p-3">
      @if (isVmWareOrProxmox()) {
        <div class="form-row">
          <div class="col-6">
            <mbs-select
              formControlName="datastore"
              [appendTo]="'.modal-content'"
              [bindLabel]="'name'"
              [bindValue]="'name'"
              [clearable]="false"
              [id]="'retore-ibb-to-vm-settings-data-store-select'"
              [items]="dataStoreList()"
              [label]="'wizards:datastoreTitle' | i18next"
              [loading]="dataStoreLoading()"
              [searchable]="false"
              [showRequiredMark]="false"
              [textOverflow]="false">
              <ng-template
                #mbsSelectLabelTmp
                let-item="item">
                {{ item.name }} {{ item?.name ? ('wizards:vmDatastoreFree' | i18next: { size: (item.freeSpace | size) }) : '' }}
              </ng-template>
              <ng-template
                #mbsSelectOptionTmp
                let-item="item">
                {{ item.name }} {{ 'wizards:vmDatastoreFree' | i18next: { size: (item.freeSpace | size) } }}
              </ng-template>
            </mbs-select>
          </div>
          <div class="col-6">
            @if (!isProxmox()) {
              <mbs-select
                formControlName="diskProvision"
                [appendTo]="'.modal-content'"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [id]="'vm-settings-disk-provision-select'"
                [items]="diskProvisionList()"
                [label]="'wizards:vmDiskProvisioning' | i18next"
                [searchable]="false"
                [showRequiredMark]="false"
                [textOverflow]="false"></mbs-select>
            }
          </div>
        </div>
      } @else if (showDestinationFolder()) {
        <div class="form-row">
          <div class="col-12">
            <mbs-destination-folder-input
              [buttonId]="'vm-settings-destination-folder-tree-2'"
              [control]="stepForm.controls.destination"
              [destinationFolderParams]="destinationFolderParams()"
              [hasTargetComputer]="!!mainService?.targetComputerData"
              [inputId]="'vm-settings-destination-folder-2'"
              [isUnix]="mainService?.isUnix"
              [name]="'vm-settings-destinationFolder'"
              [pathValidationEnabled]="isHyperV()"
              [requiredValidationEnabled]="!(isVmWareOrProxmox() || isInstantRestore())"></mbs-destination-folder-input>
          </div>
        </div>
      }
    </mbs-card-group>

    <mbs-card-group class="w-100 p-3">
      <div
        class="form-row"
        [class.mb-3]="!isVmWareOrProxmox()">
        <div class="col-6">
          <mbs-number
            formControlName="numCPU"
            [label]="'wizards:consistencyCheck.numCpuNumberLabel' | i18next"
            [max]="100"
            [min]="1"
            [showRequiredMark]="false"></mbs-number>
        </div>
        <div class="col-6">
          <mbs-number
            formControlName="memorySize"
            [label]="'wizards:vmSettingsMemory' | i18next"
            [max]="maxStartupRAM"
            [min]="memorySizeIsFocused() ? 0 : minStartupRAM"
            [showRequiredMark]="false"
            (blur)="memorySizeBlurHandler()"
            (focus)="memorySizeIsFocused.set(true)"></mbs-number>
        </div>
      </div>

      @if (showDynamicMemory()) {
        <div class="form-row align-items-center">
          <div class="col-auto">
            <mbs-switcher
              formControlName="dynamic"
              [descriptionOutside]="false"
              [id]="'vm-settings-dynamic-switcher'"
              [label]="'wizards:vmDynamic' | i18next">
            </mbs-switcher>
          </div>
          <div class="col-auto">
            <label
              class="mbs-form_label fw-bold mb-0 ml-3"
              for="vm-settings-min-memory-size">
              {{ 'wizards:vmMinMemory' | i18next }}
            </label>
          </div>
          <div class="col">
            <mbs-number
              formControlName="minMemorySize"
              [disabledSelf]="!value()?.dynamic"
              [id]="'vm-settings-min-memory-size'"
              [isErrorsShow]="false"
              [max]="maxStartupRAM"
              [min]="minMemorySizeIsFocused() ? 0 : minStartupRAM"
              [showRequiredMark]="false"
              (blur)="minMemorySizeBlurHandler()"
              (focus)="minMemorySizeIsFocused.set(true)"></mbs-number>
          </div>
          <div class="col-auto">
            <label
              class="mbs-form_label fw-bold mb-0"
              for="vm-settings-max-memory-size">
              {{ 'wizards:vmMaxMemory' | i18next }}
            </label>
          </div>
          <div class="col">
            <mbs-number
              formControlName="maxMemorySize"
              [disabledSelf]="!value()?.dynamic"
              [id]="'vm-settings-max-memory-size'"
              [isErrorsShow]="false"
              [max]="maxStartupRAM"
              [min]="maxMemorySizeIsFocused() ? 0 : minStartupRAM"
              [showRequiredMark]="false"
              (blur)="maxMemorySizeBlurHandler()"
              (focus)="maxMemorySizeIsFocused.set(true)"></mbs-number>
          </div>
          @let minMemorySizeInvalid =
            stepForm?.get('minMemorySize')?.errors?.minMemorySizeInvalid || stepForm?.get('maxMemorySize')?.errors?.maxMemorySizeInvalid;
          @if (minMemorySizeInvalid) {
            <div class="col-12 d-flex align-items-center">
              <mbs-input-errors [errors]="[{ message: ('wizards:vmMinMaxMemoryError' | i18next) }]"></mbs-input-errors>
            </div>
          } @else {
            @let minMaxMemoryError =
              stepForm?.get('minMemorySize')?.errors?.minMaxMemoryError || stepForm?.get('maxMemorySize')?.errors?.minMaxMemoryError;

            @if (minMaxMemoryError) {
              <div class="col-12 d-flex align-items-center">
                <mbs-input-errors [errors]="[minMaxMemoryError]"></mbs-input-errors>
              </div>
            }
          }
        </div>
      }
    </mbs-card-group>

    <mbs-card-group class="w-100 p-3">
      <div class="form-row">
        <div class="col-6">
          <mbs-select
            formControlName="virtualNetwork"
            [appendTo]="'.modal-content'"
            [clearable]="false"
            [id]="'retore-ibb-to-vm-settings-virtual-network-select'"
            [items]="virtualNetworkList()"
            [label]="(isProxmox() ? 'wizards:vmNetworkProxmox' : 'wizards:vmNetwork') | i18next"
            [loading]="networksLoading()"
            [searchable]="false"
            [showRequiredMark]="false"
            [textOverflow]="false"></mbs-select>

          @if (isProxmox()) {
            <mbs-select
              class="d-block ml-3 mt-3"
              formControlName="cardModel"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [disabledSelf]="!stepForm.get('virtualNetwork').value"
              [id]="'retore-ibb-to-vm-settings-card-model-select'"
              [items]="cardModelsList()"
              [label]="'wizards:vmNetworkCardModel' | i18next"
              [loading]="cardModelsLoading()"
              [searchable]="false"
              [showRequiredMark]="false"
              [textOverflow]="false"></mbs-select>
          }
        </div>

        <div class="col-6">
          @if (isVmWareOrProxmox()) {
            <mbs-select
              formControlName="guestOs"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [id]="'retore-ibb-to-vm-settings-guest-os-select'"
              [items]="guestOsList()"
              [label]="'wizards:vmGuestOs' | i18next"
              [loading]="guestOsLoading()"
              [searchable]="false"
              [showRequiredMark]="false"
              [textOverflow]="false"></mbs-select>
          } @else if (!isInstantRestore()) {
            <mbs-select
              formControlName="generation"
              [appendTo]="'.modal-content'"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [clearable]="false"
              [id]="'vm-settings-generation-select'"
              [items]="generationList()"
              [label]="'wizards:vmGeneration' | i18next"
              [searchable]="false"
              [showRequiredMark]="false"
              [textOverflow]="false"></mbs-select>
          }
        </div>
      </div>
    </mbs-card-group>

    @if (!isInstantRestore()) {
      <mbs-card-group class="w-100 p-3">
        <mbs-switcher
          formControlName="powerOn"
          [id]="'vm-settings-power-on-vm-switcher'"
          [label]="'wizards:powerOnVMLabel' | i18next"></mbs-switcher>
      </mbs-card-group>
    }
  </mbs-card>
</section>
